import { AlertIcon } from 'components/icons';
import { Button } from 'components/ui/Button';

/**
 * Friendly error panel. Pass an Apollo/JS `error` (its message is shown) or a
 * custom `title`/`description`, plus an optional `onRetry` handler.
 */
export function ErrorState({ title = 'Something went wrong', description, error, onRetry }) {
  const message = description || error?.message || 'Please try again in a moment.';

  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-center">
      <span className="flex h-12 w-12 items-center justify-center rounded-full bg-red-50 text-red-500">
        <AlertIcon className="h-6 w-6" />
      </span>
      <div>
        <h3 className="text-base font-semibold text-slate-900">{title}</h3>
        <p className="mt-1 max-w-md text-sm text-slate-500">{message}</p>
      </div>
      {onRetry && (
        <Button variant="secondary" size="sm" onClick={onRetry}>
          Try again
        </Button>
      )}
    </div>
  );
}

export default ErrorState;
